import { ChosenIcon, ChosenIconName } from "@components/svg/ChosenIcon"
import { Link } from "eddev/routing"
import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"

type Props = {
  href: string
  target?: string
  icon?: ChosenIconName | (string & {})
  title: ReactNode
  chips: ReactNode
  className?: string
}

export function FileItem(props: Props) {
  return (
    <Link
      href={props.href}
      className={twMerge("group stack-y-0 items-center !outline-none !shadow-none", props.className)}
      draggable={false}
      target={props.target}
    >
      <ChosenIcon icon={(props.icon as ChosenIconName) ?? "file"} className="w-[40%] h-auto " />
      <div className="stack-y-3 items-center justify-center w-full">
        <div className="type-title-s-medium text-center">{props.title}</div>
        {props.chips}
      </div>
    </Link>
  )
}
